export default "__VITE_ASSET__DpG0gR92__"